export default "__VITE_ASSET__CLK9z7hP__"